/**
 * Miradi Share UX Services
 * Miradi Share UX Services end-point (for internal use only)
 *
 * OpenAPI spec version: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { ProgramRoleEnum } from './programRoleEnum';
import { ProgramFeaturePermission } from './programFeaturePermission';


/**
 * Miradi Share Program Permission
 */
import { ValidateUtils } from 'app/shared/utils';

export class ProgramPermission { 
    /**
     * Unique identifier for Program
     */
    readonly programIdentifier?: string;
    /**
     * Program name
     */
    readonly programName?: string;
    programRole?: ProgramRoleEnum;
    /**
     * List of feature permissions
     */
    readonly featurePermissions?: Array<ProgramFeaturePermission>;

    constructor(item?: Partial<ProgramPermission>) {
        
        Object.assign(this, item);
    }

    static getValidationObject(): any {
        return {
            programIdentifier: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.programIdentifier : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            programName: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.programName : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            programRole: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.programRole : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            featurePermissions: {
                
                
                
                isValid: (itemOrValue: any) => {
                    let result = true;

                    let value = itemOrValue === Object(itemOrValue) ? itemOrValue.featurePermissions : itemOrValue;

                    if (['uuid'].indexOf('') === -1 || value != null) {
                      result = result && ValidateUtils.isValidLength(value, null, );
                    }

                    return result;
                }
            },
            isValid: ProgramPermission.isValid,
        };
    }

    static isValid(obj: ProgramPermission): boolean {
        if (!!obj) {
            const item = obj as any; // just to make things easier in this generated code...
            const validationObject = ProgramPermission.getValidationObject();
            let result = !item.$validationMessage;
            result = result && validationObject.programIdentifier.isValid(item);
            result = result && validationObject.programName.isValid(item);
            result = result && validationObject.programRole.isValid(item);
            result = result && validationObject.featurePermissions.isValid(item);
            return result;
        } else {
            return false
        }
    }
}

